define('GoferParts.Diagrams.View', [
  'SCView',
  'Utils',
  'Utilities.ResizeImage',
  'ShopByModel.Model',
  'gofer_parts_diagrams.tpl'
], function (SCViewModule, Utils, resizeImage, GoferModelModel, gofer_parts_diagrams_tpl) {
  'use strict';

  var SCView = SCViewModule.SCView;
  var self;

  function GoferPartsDiagramsDetailsView(options) {
    try {
      SCView.call(this, options);

      self = this;
      this.application = options.application;
      this.template = gofer_parts_diagrams_tpl;
      this.model = new GoferModelModel();
      this.list = [];
      this.diagramParts = [];
      this.images = [];
      this.args = options.args;
      this.customerId = '';
      this.pages = options.pages
        .sort(function (a, b) {
          return parseInt(a.pageNumber) - parseInt(b.pageNumber);
        })
        .map(function (page) {
          return {
            name: page.name,
            url: [
              '/gofer-parts' + '/' + self.args.modelName,
              '?diagrams=' + page.name.replace(/\//g, '---') // Forward slashes cause a navigation issue
            ].join(''),
            imageUrlComponent:
              'https://' + SC.ENVIRONMENT.currentHostString + '/' + page.imageUrlComponent
          };
        });

      if (!!this.args.params.diagrams) {
        this.initDiagram();
      }

      this.application.getLayout().on('afterAppendView', function () {
        $('[data-toggle="popover"]').each(function (index, element) {
          jQuery(element).popover({
            trigger: 'hover',
            html: true,
            content: function () {
              return '<img class="img-fluid" src="' + $(this).data('img') + '" />';
            },
            title: $(this).data('name')
          });
        });
      });
    } catch (err) {
      console.error(674920, err);
    }
  }

  GoferPartsDiagramsDetailsView.prototype = Object.create(SCView.prototype);
  GoferPartsDiagramsDetailsView.prototype.constructor = GoferPartsDiagramsDetailsView;

  GoferPartsDiagramsDetailsView.prototype.initDiagram = function () {
    try {
      // options.value is the parameter value when URL has ?diagram=
      this.isLoggedIn = false;
      var self = this;
      this.application
        .getComponent('UserProfile')
        .getUserProfile()
        .then(function (profile) {
          try {
            var isLoggedIn = profile.isloggedin;
            self.isLoggedIn = isLoggedIn;
            var hasId = profile.internalid && profile.internalid != '0';
            self.customerId = isLoggedIn && hasId ? profile.internalid : '';
            self.getDiagramParts().then(function () {
              self.initZoom();
            });
          } catch (err) {
            console.error(840288, err);
          }
        });
    } catch (err) {
      console.error(129488, err);
    }
  };

  GoferPartsDiagramsDetailsView.prototype.getDiagramParts = function () {
    try {
      var self = this;
      var deferred = jQuery.Deferred();
      var data = {
        goferModel: this.args.modelName,
        diagramPage: this.args.params.diagrams,
        customerId: this.customerId
      };

      this.model
        .fetch({ data: data })
        .then(function (res) {
          try {
            res.forEach(function (part) {
              try {
                var exists = !!self.diagramParts.find(function (d) {
                  return (
                    d.description == part.description &&
                    parseInt(d.itemImageRef) == parseInt(part.itemImageRef)
                  );
                });
                if (exists) {
                  return true;
                }

                part.itemImageRef = part.itemImageRef.padStart(3, '0');

                // var src = window.location.origin + '/' + part.imageUrlComponent;
                if (
                  !self.images.find(function (i) {
                    return i.src == part.imageUrlComponent;
                  })
                ) {
                  self.images.push({
                    src: part.imageUrlComponent,
                    pageNumber: parseInt(part.pageNumber)
                  });
                }

                if (part.item && part.item.price) {
                  if (part.item.price) {
                    part.item.price = Utils.formatCurrency(part.item.price);
                  }
                }

                self.diagramParts.push(part);
              } catch (err) {
                console.error(289457, err);
              }
            });

            self.diagramParts = self.diagramParts.sort(function (a, b) {
              return parseInt(a.itemImageRef) - parseInt(b.itemImageRef);
            });

            self.images = self.images.sort(function (a, b) {
              return a.pageNumber - b.pageNumber;
            });

            self.render();

            deferred.resolve();
          } catch (err) {
            console.error(612994, err);
          }
        })
        .fail(function (res) {
          console.error(203992, res);
        });

      return deferred;
    } catch (err) {
      console.error(205929, err);
    }
  };

  GoferPartsDiagramsDetailsView.prototype.initZoom = function () {
    var self = this;

    if (!SC.ENVIRONMENT.isTouchEnabled && !self.$slider) {
      this.$('[data-zoom]:not(.bx-clone)').each(function (slide_index) {
        self.$(this).zoom(resizeImage(self.images[slide_index].src, 'zoom'), slide_index);
      });
    }
  };

  GoferPartsDiagramsDetailsView.prototype.getContext = function () {
    for(var i = 0; i<this.diagramParts.length;i++){
      this.diagramParts[i].isLoggedIn = this.isLoggedIn;
    }
    try {
      var cont = {
        isLoggedIn:this.isLoggedIn,
        diagramParts: this.diagramParts,
        images: this.images,
        modelName: this.args.modelName,
        pages: this.pages,
        pageName: this.args.params.diagrams,
        showPages: !this.args.params.diagrams,
        isDesktopDevice: Utils.isDesktopDevice()
      };
      return cont;
    } catch (err) {
      console.error(352082, err);
    }
  };

  return GoferPartsDiagramsDetailsView;
});
